'use client';

import type { CSSProperties, ReactNode } from 'react';

function normalizeHex(color?: string | null): string | undefined {
  if (!color) return undefined;
  const trimmed = color.trim();
  if (/^#[0-9a-fA-F]{3,8}$/.test(trimmed)) return trimmed;
  if (/^[0-9a-fA-F]{3,8}$/.test(trimmed)) return `#${trimmed}`;
  return trimmed;
}

export interface SubscriptionOrgTheme {
  name: string;
  slug: string;
  logo_url?: string;
  primary_color?: string;
  secondary_color?: string;
}

interface SubscriptionStoreThemeProps {
  organization: SubscriptionOrgTheme;
  children: ReactNode;
}

export function SubscriptionStoreTheme({ organization, children }: SubscriptionStoreThemeProps) {
  const accent = normalizeHex(organization.primary_color) ?? undefined;
  const accentSecondary = normalizeHex(organization.secondary_color) ?? accent;

  const style = {
    ...(accent ? { '--subs-accent': accent } : {}),
    ...(accentSecondary ? { '--subs-accent-secondary': accentSecondary } : {}),
  } as CSSProperties;

  return (
    <div
      className="subscription-store-theme [--subs-accent:var(--primary)] [--subs-accent-secondary:var(--primary)]"
      style={style}
    >
      {children}
    </div>
  );
}
